import { render, staticRenderFns } from "./AddLabelButton.vue?vue&type=template&id=cc6468e8&"
import script from "./AddLabelButton.vue?vue&type=script&lang=js&"
export * from "./AddLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports